import { Component } from '@angular/core';

@Component({
  selector: 'app-atlastrackerindex',
  standalone: true,
  imports: [],
  templateUrl: './atlastrackerindex.component.html',
  styleUrl: './atlastrackerindex.component.css'
})
export class AtlastrackerindexComponent {

}
